import api from './http-common';
import axios from 'axios';
import {format, parse} from 'date-fns';
import {token} from '../common/const/token-helper';
import {SERVER} from '../common/const/networkUrls';
import {IsUnauthorized} from '../common/utility/utility';

export async function fetchLabelTranslationApi(id) {
    try {
         const response =  await api.get(`${SERVER.SERVICES.getLabelsTranslation}/${id=parseInt(id)}`);  
         const body = await response;
         return body.data;
    } catch(error) {
        IsUnauthorized(error);
        return error;
    }
}

export const fetchMetaDataApi = async (id) => {
    try {
          const response = await api.get(`${SERVER.SERVICES.getConfig}/${id}`);  
          const body = await response;
          return body.data;
    } catch(error) {
        IsUnauthorized(error);
        return error;
    }
}

export const uploadFileApi = async (uploadedFile, bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly) => {
    let formData = new FormData();
    formData.append("formFile", uploadedFile)
    let url = null

    if(!isWeekly)
    {
        revenueDate = format(parse(revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        url = await api.post(`${SERVER.SERVICES.importRevenueDetails}?businessPartnerCode=${bpCode}&revenueDate=${revenueDate}&languageId=${selectedLangId}`, formData, {
            headers: {
                "Content-Type" : "multipart/form-data",
                "Cache-Control": "no-cache"
            }
       }); 
    }
    else
    {        
        startDate = format(parse(startDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        endDate = format(parse(endDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        url = await api.post(`${SERVER.SERVICES.importWeeklyRevenueDetails}?businessPartnerCode=${bpCode}&weeklyStartDate=${startDate}&weeklyEndDate=${endDate}&languageId=${selectedLangId}`, formData, {
            headers: {
                "Content-Type" : "multipart/form-data",
                "Cache-Control": "no-cache"
            }
       });
    }
    let response = await url;
    const body = await response;
    return body.data;
}

export const exportToExcelFileDailyRevenueApi = async (bpCode, revenueDate, startDate, endDate, selectedLangId, isWeekly) => {
    let url = null
    if(!isWeekly)
    {
        revenueDate = format(parse(revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        url = `${SERVER.API_BASE_URL}${SERVER.SERVICES.exportRevenueDetails}?businessPartnerCode=${bpCode}&revenueDate=${revenueDate}&languageId=${selectedLangId}`;
    }
    else
    {
        startDate = format(parse(startDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        endDate = format(parse(endDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy")
        url = `${SERVER.API_BASE_URL}${SERVER.SERVICES.exportWeeklyRevenueDetails}?businessPartnerCode=${bpCode}&weeklyStartDate=${startDate}&weeklyEndDate=${endDate}&languageId=${selectedLangId}`;
    }
    const method = 'GET';
    return await downloadFile(url, method, null);
}

export const exportToExcelFileOverviewDetailsApi = async (overviewDetailsRequest) => {
    overviewDetailsRequest = {...overviewDetailsRequest, 
        FromDate : format(parse(overviewDetailsRequest.FromDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" ),
        ToDate   :format(parse(overviewDetailsRequest.ToDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy" )
    }
    const url = `${SERVER.API_BASE_URL}${SERVER.SERVICES.exportOverviewDetails}`;
    const method = 'POST';
    return await downloadFile(url, method, overviewDetailsRequest);
}

export const exportToExcelFileAuditDetailsApi = async (auditRequest) => {
    const url = `${SERVER.API_BASE_URL}${SERVER.SERVICES.exportAuditDetails}`;
    const method = 'POST';
    return await downloadFile(url, method, auditRequest);
}

export const downloadCashRegisterApi = async (contractCode, revenueDate, isRevisedFile ) => {
    const request = {
        "IntakeBookDate": format(parse(revenueDate, "dd/MM/yyyy", new Date()),"MM/dd/yyyy"),
        "ContractCode": contractCode,
        "isRevisedFile" : isRevisedFile
    } 

    const url = `${SERVER.API_BASE_URL}${SERVER.SERVICES.downloadIntakeBookFile}`;
    const method = 'POST';
    return await downloadFile(url, method, request);
}

export const fetchRemarksOptionsApi = async () => {
    try {
        const response = await api.get(`${SERVER.SERVICES.getRemarkOptions}`);  
        const body = await response;
        return body.data;
    } catch(error) {
        IsUnauthorized(error);
        return error;
    }
}

export async function fetchChangeRequestOverviewApi(bpCode)
{
    const url = !bpCode ? `${SERVER.SERVICES.getChangeRequestOverviewDetails}` 
                : `${SERVER.SERVICES.getChangeRequestBPOverviewDetails}?businessPartnerCode=${bpCode}`;

    const response =  await api.get(url);  
    const body = await response;
    return body.data;
}

const downloadFile = async (url, method, inputData) => {
   const response = await axios({
        url: url,
        method: method,
        headers: {
            "Pragma": "no-cache",
            "Cache-Control": "no-cache",
            "csrf": "token",
            "Authorization": `Bearer ${token}`
        },
        responseType: 'blob',
        data: inputData
    })
    
    const body = await response;
    return body.data;
}
